export const OUT = 0;
export const HOVER = 1;
export const NEED_CONFIRM = 2;
